import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronUpIcon } from 'assets/icons';

import {
  AccordionHeader,
  AccordionTitle,
  AccordionTitleWrapper,
  Container,
} from './Accordion.styled';
import { useTheme } from 'styled-components';

type TAccordionType = 'primary' | 'secondary';

export const Accordion = ({
  padding,
  type,
  title,
  title2,
  title3,
  children,
  disabled = false,
  disableBorderBottom,
  titleBadge,
  titleBadgeLeft,
  titleBadgeReverseChipMobile,
  dataTestId,
  backgroundColor,
  backgroundColorHeader,
  open,
}: {
  padding?: string;
  type: TAccordionType;
  title: string | ReactNode;
  title2?: string | ReactNode;
  title3?: string;
  children?: ReactNode | Array<any>;
  disabled?: boolean;
  disableBorderBottom?: boolean;
  titleBadge?: ReactNode;
  titleBadgeLeft?: boolean;
  titleBadgeReverseChipMobile?: boolean;
  dataTestId?: string;
  backgroundColor?: string;
  backgroundColorHeader?: string;
  open?: boolean;
}) => {
  const [expanded, setExpanded] = useState(open || false);
  const { t } = useTranslation();
  const { colors } = useTheme();

  const toggleExpanded = () => {
    if (disabled) {
      return null;
    }

    return setExpanded(!expanded);
  };

  return (
    <Container
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
      backgroundColor={backgroundColor}
    >
      <AccordionHeader
        padding={padding}
        type={type}
        onClick={toggleExpanded}
        expanded={expanded}
        disableBorderBottom={disableBorderBottom}
        backgroundColorHeader={backgroundColorHeader}
      >
        <AccordionTitleWrapper width="100%">
          <AccordionTitle
            titleBadgeReverseChipMobile={titleBadgeReverseChipMobile}
            width={title2 && !title3 ? '50%' : !title2 && !title3 ? 'initial' : '35%'}
            type={type}
          >
            {titleBadge && titleBadgeLeft && titleBadge}
            {typeof title === 'string' ? title || t(title) : title}
            {titleBadge && !titleBadgeLeft && titleBadge}
          </AccordionTitle>

          {title2 && (
            <AccordionTitle width={!title3 ? '50%' : '35%'} type={type} titleBorder={!!title2}>
              {typeof title2 === 'string' ? title2 || t(title2) : title2}
            </AccordionTitle>
          )}

          {title3 && (
            <AccordionTitle width="32.5%" type={type} titleBorder={!!title3}>
              {title3 || t(title3)}
            </AccordionTitle>
          )}
        </AccordionTitleWrapper>

        <ChevronUpIcon stroke={colors.black_60} rotate={expanded ? 0 : 180} />
      </AccordionHeader>
      {expanded && children}
    </Container>
  );
};
